/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import { PropsWithChildren } from 'react';

// UI lib components
import { Box } from '@mantine/core';

// UI local components
import { Title } from '@components/v2/ui/Title';

// Styles
import classes from './ProfileSectionCard.module.css';

/* -------------------------------------------------------------------------- */
/*                                     Type                                   */
/* -------------------------------------------------------------------------- */
type TProfileSectionCardProps = PropsWithChildren<{
	title: string;
}>;

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
const ProfileSectionCard = ({
	title,
	children,
}: TProfileSectionCardProps) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<Title order={6} c={'#1D3965'}>
				{title}
			</Title>
			{children}
		</Box>
	);
};

export default ProfileSectionCard;
